import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	label: {
		id: 'app.packRowList.label',
		defaultMessage: 'Content row for {title}',
		description: 'Screen reader label for a playlist row item',
	},
	lockedLabel: {
		id: 'app.packRowList.lockedLabel',
		defaultMessage: 'Locked content row for {title}',
		description: 'Screen reader label for a row whose content needs a subscription',
	},
	playAriaLabel: {
		id: 'app.packRowList.playlistHeader.playAriaLabel',
		defaultMessage: 'Play {title}',
		description: 'Screen reader label for the playlist header play button',
	},
	shuffleAriaLabel: {
		id: 'app.packRowList.playlistHeader.shuffleAriaLabel',
		defaultMessage: 'Shuffle play {title}',
		description: 'Screen reader label for the playlist header shuffle button',
	},
	curatorAriaLabel: {
		id: 'app.packRowList.playlistHeader.curatorAriaLabel',
		defaultMessage: "View {curator}'s page",
		description: 'Screen reader label for the playlist header curator attribution link',
	},
	playLabel: {
		id: 'app.packRowList.playlistHeader.playLabel',
		defaultMessage: 'Play',
		description: 'Visible label for the playlist header play button',
	},
	pauseAriaLabel: {
		id: 'app.packRowList.playlistHeader.pauseAriaLabel',
		defaultMessage: 'Pause {title}',
		description: 'Screen reader label for the playlist header play button while one of its tracks is playing',
	},
	pauseLabel: {
		id: 'app.packRowList.playlistHeader.pauseLabel',
		defaultMessage: 'Pause',
		description: 'Visible label for the playlist header play button while one of its tracks is playing',
	},
	shuffleLabel: {
		id: 'app.packRowList.playlistHeader.shuffleLabel',
		defaultMessage: 'Shuffle',
		description: 'Visible label for the playlist header shuffle button',
	},
	trackSummary: {
		id: 'app.packRowList.playlistHeader.trackSummary',
		defaultMessage: '{count, plural, one {# track} other {# tracks}} • {hours} hr {minutes} min',
		description:
			'Track count and total duration summary shown under a playlist header title, e.g. "11 tracks • 5 hr 43 min"',
	},
	trackCount: {
		id: 'app.packRowList.playlistHeader.trackCount',
		defaultMessage: '{count, plural, one {# track} other {# tracks}}',
		description: 'Track count shown under a playlist header title when the total duration is unavailable',
	},
	newTag: {
		id: 'app.packRowList.newTag',
		defaultMessage: 'New',
		description: 'Badge on the artwork of a row for newly added content',
	},
});
